export default {
  setTheme (state, { theme }) {
    state.theme = theme;
  },
  setCookieBanner (state, payload) {
    state.cookieBanner = payload;
  },
  setDisplayingCookieBanner (state, payload) {
    state.showCookieConsent = payload;
  }
};
